export default "__VITE_ASSET__0f362ff7__"